import { DollarSign, MapPin, Clock, ShieldCheck } from "lucide-react"
import ServiceCard from "./ServiceCard"

export default function ServicesSection() {
  const services = [
    {
      icon: DollarSign,
      title: "CAMBIO USD/MXN",
      description: "Compra y venta de dólares al mejor tipo de cambio",
      link: "#stats-section"
    },
    {
      icon: MapPin,
      title: "NUESTRAS SUCURSALES",
      description: "Dos ubicaciones estratégicas en Mexicali",
      link: "#about-section"
    },
    {
      icon: Clock,
      title: "HORARIOS Y CONTACTO",
      description: "Lun-Sáb 7:00-23:00 | Dom 7:00-19:00",
      link: "#footer"
    },
    {
      icon: ShieldCheck,
      title: "REQUISITOS",
      description: "Documentos necesarios según tu operación",
      link: "#requisitos-section"
    },
  ]

  const handleCardClick = (link) => {
    const element = document.querySelector(link)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  return (
    <section className="relative py-16" style={{ zIndex: 50 }}>
      <div className="max-w-6xl mx-auto px-4">
        <div className="bg-brand-white rounded-2xl shadow-2xl p-4 md:p-6 lg:p-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 items-stretch divide-y md:divide-y-0 md:divide-x divide-gray-100">
            {services.map((service, index) => (
              <div key={index} className="flex justify-center items-stretch">
                <div className="w-full" onClick={() => handleCardClick(service.link)}>
                  <ServiceCard {...service} highlighted={index === 0} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}